import { ArrowRight, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { useSeo } from "~/lib/seo/useSeo";
import { ASSETS } from "~/lib/tutorials/cabecudo";

export function Tutorial() {
  useSeo({
    title: "Tutorial",
    description:
      "Tutoriais de inteligência artificial com exemplos reais, arquivos para baixar e passos fáceis de seguir.",
    pathname: "/tutorial",
  });
  return (
    <section
      lang="pt-BR"
      className="tutorial-page mx-auto max-w-6xl px-5 py-12 sm:px-8 sm:py-20"
    >
      <p className="tutorial-eyebrow">Aprenda fazendo</p>
      <h1 className="mt-4 font-display text-4xl font-semibold tracking-tight sm:text-6xl">
        Tutorial
      </h1>
      <p className="mt-5 max-w-xl text-lg leading-relaxed text-jg-fg-muted">
        Projetos reais, explicados do começo ao fim. Com os arquivos, os textos
        prontos e cada passo para você repetir.
      </p>
      <Link
        to="/tutorial/cabecudo"
        className="tutorial-feature mt-12 grid overflow-hidden rounded-2xl border border-jg-border bg-jg-bg-soft md:grid-cols-[.85fr_1.15fr]"
      >
        <div className="relative flex min-h-72 items-center justify-center bg-[#1c2022] px-8 pt-8">
          <img
            src={`${ASSETS}/personagem-corpo.webp`}
            alt="Cabeçudo: personagem de terno marrom, bigode e cabelo loiro"
            width="864"
            height="1152"
            className="h-80 w-auto rounded-t-xl object-contain sm:h-96"
          />
          <span className="absolute left-5 top-5 rounded-full bg-jg-bg px-3 py-1 text-xs text-jg-ai">
            Vídeo com IA
          </span>
        </div>
        <div className="flex flex-col justify-center p-7 sm:p-12">
          <p className="tutorial-eyebrow">01 / Kling · para iniciantes</p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight">
            Cabeçudo
          </h2>
          <p className="mt-4 leading-relaxed text-jg-fg-muted">
            Troque uma pessoa de um vídeo por um personagem, usando duas imagens
            de referência. Veja o antes e o depois e faça o seu.
          </p>
          <p className="mt-6 flex items-center gap-2 text-sm text-jg-fg-muted">
            <Download size={16} aria-hidden="true" /> Imagens + prompt + roteiro
            prontos
          </p>
          <span className="mt-8 flex items-center gap-3 font-medium text-jg-ai">
            Abrir tutorial <ArrowRight size={20} aria-hidden="true" />
          </span>
        </div>
      </Link>
    </section>
  );
}
